import { __assign } from "tslib";
import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { normalizePremiumFolderData } from '../../../../../../utils/normalizePremiumFolderData';
import getBiDataForDeviationLink from '../../../../../../Duperbrowse/DeviationLink/getBiDataForDeviationLink';
import Button from '../../../../../../Button';
import PointsIcon from '../../../../../../Icons/Points';
import { MobileContext } from '../../../../../../Context';
import { IconSize } from '../../../../../../Icons/IconWrap';
import { BiEventType } from '../../../../../../biLogger/constants';
import { ThemeOverride } from '../../../../../../Context/ThemeContext';
import { ThemeOptions } from '../../../../../../publicSession/types';
import { getDeviationType } from '../../../../../_helpers';
import { useFlag } from '../../../../../../redux/flags/hooks';
import s from './ThumbPaywall.scss';
var PaidThumbPaywall = function (_a) {
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className, startFolderAccess = _a.startFolderAccess;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var newCheckout = useFlag('new_checkout');
    var _b = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData, true), dollarPrice = _b.dollarPrice, pointPrice = _b.pointPrice, folderId = _b.folderId, subproductId = _b.subproductId;
    var isLiterature = getDeviationType(deviation) === 'literature';
    var onUnlockClick = useCallback(function (e) {
        if (folderId) {
            startFolderAccess(folderId);
            e.preventDefault();
            e.stopPropagation();
        }
    }, [folderId, startFolderAccess]);
    return (React.createElement("div", { className: classnames(s['root'], isSmall && s['small'], className) },
        React.createElement("div", { className: s['label'] }, t(isMobile
            ? 'deviationview.overlay.premiumFolder.unlockHint.pay.mobile'
            : 'deviationview.overlay.premiumFolder.unlockHint.pay')),
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(Button, { view: "b18", height: "medium", className: classnames(s['button'], isLiterature && s['button-on-literature']), biData: __assign(__assign({}, getBiDataForDeviationLink(deviation)), { evid: BiEventType.GALLERY_PURCHASE, authorid: deviation.author.useridUuid, galleryid: folderId, points: pointPrice }), onClick: newCheckout ? undefined : onUnlockClick, href: newCheckout && subproductId
                    ? Url.checkoutLink(subproductId)
                    : undefined }, isSmall ? (t('deviationview.overlay.premiumFolder.button.pay.short')) : isMobile ? (React.createElement(Trans, { i18nKey: "deviationview.overlay.premiumFolder.button.pay.mobile" },
                "Unlock for ",
                { dollarPrice: dollarPrice })) : (
            /* prettier-ignore */
            React.createElement(Trans, { i18nKey: "deviationview.overlay.premiumFolder.button.pay" },
                "Unlock for ",
                { dollarPrice: dollarPrice },
                " /",
                React.createElement(PointsIcon, { className: s['points-icon'], size: IconSize.TINY, disableDefaultColors: true }),
                " ",
                { pointPrice: pointPrice }))))));
};
PaidThumbPaywall.displayName = 'PaidThumbPaywall';
export default PaidThumbPaywall;
//# sourceMappingURL=PaidThumbPaywall.js.map